import { createSelector } from 'reselect';
import { PapiGallection } from '@wix/da-papi-types';
import {
  getHasMoreInDirection,
  getItems,
} from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { AppState } from '../types/store';
import {
  GALLERY_FOLDER_DEVIATIONS_STREAM,
  GALLERY_SUBFOLDERS_STREAM,
} from '../../constants';

export const getFolderDeviations = (state: AppState) =>
  getItems(state, GALLERY_FOLDER_DEVIATIONS_STREAM.streamId);

export const getHasDeviations = createSelector(
  [getFolderDeviations],
  deviations => deviations.length > 0
);

export const getSubfolders = (state: AppState) =>
  getItems<PapiGallection>(state, GALLERY_SUBFOLDERS_STREAM.streamId);

export const getVisibleSubfolders = (state: AppState) =>
  (getSubfolders(state) || []).filter(f => !f.isHidden);

export const getHasSubfolders = createSelector([getSubfolders], subfolders =>
  (subfolders ?? []).some(f => !f.isHidden)
);

export const getHasMoreSubfolders = (state: AppState) =>
  getHasMoreInDirection(state, GALLERY_SUBFOLDERS_STREAM.streamId, 'next');
